import { render, staticRenderFns } from "./orderQueryDetail.vue?vue&type=template&id=187975c8&scoped=true&"
import script from "./orderQueryDetail.vue?vue&type=script&lang=js&"
export * from "./orderQueryDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderQueryDetail.vue?vue&type=style&index=0&id=187975c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187975c8",
  null
  
)

export default component.exports